<template>
    <div>
        <div class="tableSelect" ref="tableSelect">
            <el-form :inline="true" :model="formInline" label-position="left">
                <el-form-item label="地区：">
                    <el-select v-model="formInline.region" clearable @change="search" 
                        placeholder="请选择地区" style="width:120px">
                        <el-option
                            v-for="(item,index) in regionList"
                            :key="index"
                            :label="item.label"
                            :value="item.value"
                        ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="Payer名称：">
                    <el-input size="small" v-model.trim="formInline.name" maxlength="60" clearable 
                        placeholder="请输入Payer名称" @change="search" style="width:120px"></el-input>
                </el-form-item>
                <el-form-item label="PayerId：">
                    <el-input size="small" v-model.trim="formInline.payer_id" maxlength="60" clearable 
                        placeholder="请输入PayerId" @change="search" style="width:120px"></el-input>
                </el-form-item>
                <el-form-item label=""><el-button @click="search" type="primary" icon="Search">查询</el-button></el-form-item>
                <el-form-item label=""><el-button @click="reset" icon="Refresh">重置</el-button></el-form-item>
                <el-form-item label=""><el-button @click="add" type="success" icon="Plus">新增</el-button></el-form-item>
            </el-form>
        </div>
        <div>
            <el-table :height="'calc('+(tableHeight)+'px)'" stripe :data="tableData" ref="tableref" 
                v-loading="loadingPage" style="width:100%">
                <el-table-column type="index" width="70" align="center" label="序号">
                        <template #default="scope">
                            <span>{{ getIndex(scope.$index) }}</span>
                        </template>
                    </el-table-column>
                    
                    <el-table-column prop="name" label="Payer名称" min-width="90"></el-table-column>
                    <el-table-column prop="payer_id" label="PayerId" min-width="90"></el-table-column>
                    <el-table-column prop="bucket" label="Bucket" min-width="120"></el-table-column>
                    
                    <el-table-column label="已绑伙伴" min-width="200">
                        <template #default="scope">
                            {{ scope.row.agent ? scope.row.agent.company : '-' }}
                        </template>
                    </el-table-column>
                    
                    <el-table-column prop="email" label="邮箱" min-width="160"></el-table-column>
                    
                    <el-table-column prop="region" label="地区" width="80">
                        <template #default="scope">
                            <el-tag size="small" :type="scope.row.region === 'cn' ? 'success' : 'warning'">
                                {{ scope.row.region === 'cn' ? '中国' : 'Global' }}
                            </el-tag>
                        </template>
                    </el-table-column>
                    
                    <el-table-column label="状态" width="100" align="center">
                        <template #default="scope">
                            <el-tag :type="scope.row.status == '1' ? 'success' : 'danger'" size="small">
                                {{ scope.row.status == '1' ? 'Activate' : 'Inactivate' }}
                            </el-tag>
                        </template>
                    </el-table-column>
                    
                    <el-table-column label="操作" align="center" fixed="right" width="100">
                        <template #default="scope">
                            <el-button size="small" link type="primary" @click="edit(scope.row)" icon="Edit"></el-button>
                            <el-button size="small" link type="danger" @click="remove(scope.row.id)" icon="Delete"></el-button>
                        </template>
                    </el-table-column>
                </el-table>
        </div>
        <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>

        <!-- Edit/Add Dialog -->
        <el-dialog 
            v-model="dialogVisible" 
            :close-on-click-modal="false" 
            :before-close="cancel"
            width="600px"
            class="edit-dialog">
            
            <template #header>
                <div class="dialog-header">
                    <h3 class="dialog-title">
                        {{ loadingTitle }}
                    </h3>
                </div>
            </template>

            <div class="dialog-content">
                <el-form :inline="false" :model="formData" :rules="rules" ref="rulesForm" 
                    label-position="right" label-width="120px" class="edit-form">
                    <div class="form-section">
                        <el-form-item label="地区" prop="region">
                            <el-radio-group v-model="formData.region" class="setting-radio">
                                <el-radio v-for="item in regionList" :key="item.value" :label="item.value">
                                    {{ item.label }}
                                </el-radio>
                            </el-radio-group>
                        </el-form-item>
                        
                        <el-form-item label="Payer名称" prop="name">
                            <el-input v-model="formData.name" placeholder="请输入Payer名称"></el-input>
                        </el-form-item>
                        
                        <el-form-item label="PayerId" prop="payer_id">
                            <el-input v-model="formData.payer_id" placeholder="请输入PayerId"></el-input>
                        </el-form-item>
                        
                        <el-form-item label="AccessKey" prop="access_key">
                            <el-input v-model="formData.access_key" type="password" placeholder="请输入AccessKey"></el-input>
                        </el-form-item>
                        
                        <el-form-item label="SecurityKey" prop="security_key">
                            <el-input v-model="formData.security_key" type="password" placeholder="请输入SecurityKey"></el-input>
                        </el-form-item>
                        
                        <el-form-item label="是否BT账号" prop="is_bt">
                            <el-radio-group v-model="formData.is_bt" class="setting-radio">
                                <el-radio :label="false">否</el-radio>
                                <el-radio :label="true">是（Billing Transfer 接收方）</el-radio>
                            </el-radio-group>
                        </el-form-item>
                        
                        <el-form-item label="RegionName" prop="region_name">
                            <el-input v-model="formData.region_name" placeholder="请输入RegionName"></el-input>
                        </el-form-item>
                        
                        <el-form-item label="邮箱" prop="email">
                            <el-input v-model="formData.email" placeholder="请输入邮箱地址"></el-input>
                        </el-form-item>
                        
                        <el-form-item label="状态" prop="status">
                            <el-select v-model="formData.status" placeholder="请选择状态" class="full-width">
                                <el-option
                                    v-for="item in statusOptions"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value"
                                />
                            </el-select>
                        </el-form-item>
                    </div>
                </el-form>
            </div>

            <template #footer>
                <div class="dialog-footer">
                    <div class="footer-actions">
                        <el-button @click="cancel()" size="large">取消</el-button>
                        <el-button type="primary" @click="isEdit ? editSubmit(formData.id) : submitData()" size="large">
                            确定
                        </el-button>
                    </div>
                </div>
            </template>
        </el-dialog>
    </div>
</template>
<script>
import Pagination from "@/components/Pagination";
import {deleterPayer, editPayer, getPayerList, newPayer} from '@/api/api'
import {getTableHeight} from "@/utils/util";

export default {
  components: {
    Pagination
  },
  name: 'payerManage',
  data() {
    const checkEmail = (rule, value, callback) => {
      if (value) {
        var reg = /^[0-9a-zA-Z_.-]+[@][0-9a-zA-Z_.-]+([.][a-zA-Z]+)$/
        if (reg.test(value) === false) {
          callback(new Error('邮箱格式错误'))
        } else {
          callback()
        }
      } else {
        callback()
      }
    }
    return {
      loadingPage: false,
      tableHeight: 500,
      formInline: {
        region: 'cn',
        name: '',
        payer_id: '',
        page: 1,
        limit: 20,
      },
      loadingTitle: '新增Payer',
      dialogVisible: false,
      formData: {
        name: '',
        payer_id: '',
        access_key: '',
        security_key: '',
        email: '',
        region: '',
        is_bt: false,
        status: ''
      },
      isEdit: false,
      pageparm: {
        page: 1,
        limit: 20,
        total: 0
      },
      tableData: [],
      regionList: [
        {label: '中国', value: 'cn'},
        {label: 'Global', value: 'global'}
      ],
      statusOptions: [
        {label: 'Activate', value: '1'},
        {label: 'Inactivate', value: '-1'}
      ],
      rules: {
        region: [
          {required: true, message: '请选择地区', trigger: 'change'}
        ],
        name: [
          {required: true, message: '请输入Payer名称', trigger: 'blur'}
        ],
        payer_id: [
          {required: true, message: '请输入PayerId', trigger: 'blur'}
        ],
        access_key: [
          {required: true, message: '请输入AccessKey', trigger: 'blur'}
        ],
        security_key: [
          {required: true, message: '请输入SecurityKey', trigger: 'blur'}
        ],
        email: [
          {required: true, message: '请输入邮箱地址', trigger: 'blur'}, // 限制必填
          {required: true, trigger: 'blur', validator: checkEmail}
        ],
        status: [
          {required: true, message: '请选择状态', trigger: 'change'}
        ]
      }
    }
  },
  computed: {
    // Removed unused computed properties
  },
  methods: {
    //获取列表
    async getData() {
      this.loadingPage = true
      getPayerList(this.formInline).then(res => {
        this.loadingPage = false
        if (res.code === 2000) {
          this.tableData = res.data.data
          this.pageparm.page = res.data.page;
          this.pageparm.limit = res.data.limit;
          this.pageparm.total = res.data.total;
        }
      })
    },
    // 表格序列号
    getIndex($index) {
      // (当前页 - 1) * 当前显示数据条数 + 当前行数据的索引 + 1
      return (this.pageparm.page - 1) * this.pageparm.limit + $index + 1
    },
    // 新增保存payer
    submitData() {
      this.$refs.rulesForm.validate((valid) => {
        if (valid) {
          newPayer(this.formData).then(res => {
            if (res.code === 2000) {
              this.$message.success(res.msg);
              if (this.formData.region === 'global') {
                this.$notify({
                  title: '自动配置中',
                  message: '系统已开始为该 Payer 自动创建 CUR 桶 / IAM 权限 / 复制规则 / CUR2 导出，并回填 Bucket 字段。预计 1-2 分钟，可稍后刷新查看。',
                  type: 'info', duration: 6000
                });
              }
              this.dialogVisible = false;
              this.getData();
            } else {
              this.$message.error(JSON.stringify(res.msg));

            }
          })
        } else {
          return false;
        }
      });
    },
    editSubmit() {
      this.$refs.rulesForm.validate((valid) => {
        if (valid) {
          editPayer(this.formData).then(res => {
            if (res.code === 2000) {
              this.$message.success(res.msg);
              this.dialogVisible = false;
              this.getData();
            } else {
              this.$message.error(JSON.stringify(res.msg));

            }
          })
        } else {
          return false;
        }
      });
    },
    add() {
      this.cancel();
      this.dialogVisible = true;
      this.isEdit = false;
      this.loadingTitle = "新增Payer"
    },
    // 编辑payer账号
    edit(obj) {
      this.formData = JSON.parse(JSON.stringify(obj));
      this.formData.status = String(this.formData.status);
      this.dialogVisible = true;
      this.isEdit = true;
      this.loadingTitle = "编辑Payer"
    },
    // 删除payer账号
    remove(id) {
      this.$confirm('确定删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        deleterPayer({id: id}).then(res => {
          if (res.code === 2000) {
            this.$message.success(res.msg);
            this.dialogVisible = false;
            this.getData();
          } else {
            this.$message.error(JSON.stringify(res.msg));
          }
        })
      }).catch(err => {
        this.$message.error(err);
      })
    },
    cancel() {
      this.formData = {
        name: '',
        payer_id: '',
        access_key: '',
        security_key: '',
        email: '',
        region: '',
        is_bt: false
      };
      this.isEdit = false;
      this.dialogVisible = false;
      this.dialogOrg = false;
    },
    reset() {
      this.formInline = {
        region: '',
        page: 1,
        limit: 20
      }
      this.pageparm = {
        page: 1,
        limit: 20,
        total: 0
      }
      this.getData()
    },
    callFather(parm) {
      this.formInline.page = parm.page
      this.formInline.limit = parm.limit
      this.getData()
    },
    search() {
      this.formInline.page = 1
      this.formInline.limit = 20
      this.getData()
    },
    // 计算搜索栏的高度
    listenResize() {
      this.$nextTick(() => {
        this.getTheTableHeight()
      })
    },
    getTheTableHeight(){
      let tabSelectHeight = this.$refs.tableSelect?this.$refs.tableSelect.offsetHeight:0
      tabSelectHeight = this.isFull?tabSelectHeight - 110:tabSelectHeight
      this.tableHeight =  getTableHeight(tabSelectHeight)
    },
  },
  created() {
    this.getData()
  },
  mounted() {
    // 监听页面宽度变化搜索框的高度
    window.addEventListener('resize', this.listenResize);
    this.$nextTick(() => {
      this.getTheTableHeight()
    })
  },
  unmounted() {
    // 页面销毁，去掉监听事件
    window.removeEventListener("resize", this.listenResize);
  },
}
</script>


